import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";

@Injectable({
    providedIn: 'root'
})
export class ContractExternalBillingRecordService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ci/contractExternalBillingRecords')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-file-invoice-dollar';
    }

    getObjectLabels(): string[] {
        return ['postingDate', 'collectionType', 'grossPremium'];
    }

}
